import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'lilu-category-grid',
    styleUrl: 'lilu-category-grid.scss',
    shadow: true
})
export class LiluCategoryGrid {

    @Prop() columns = '3';

    render() {
        return (
            <section class="categories">
                <div class={`grid columns-${this.columns}`}>
                    <slot></slot>
                </div>
            </section>
        );
    }
}
